import Vue from 'vue';
import axios from 'axios';

export default {
  namespaced: true,
  state: {
    shippingOfflineLocations: [],
    shippingOfflineLocation: {},
    shippingOfflineLocationForm: false,
    operation: null,
    pending: false
  },
  mutations: {
    setShippingOfflineLocations(state, shippingOfflineLocations) {
      state.shippingOfflineLocations = shippingOfflineLocations;
    },
    setShippingOfflineLocation(state, shippingOfflineLocation) {
      state.shippingOfflineLocation = shippingOfflineLocation;
    },
    append(state, shippingOfflineLocation) {
      const found = state.shippingOfflineLocations.find(sl => sl.id == shippingOfflineLocation.id);
      if (!found) {
        state.shippingOfflineLocations.push(shippingOfflineLocation);
        state.shippingOfflineLocation = shippingOfflineLocation;
      }
    },
    replace(state, { o, n }) {
      const i = _.findIndex(state.shippingOfflineLocations, { id: o.id });
      if (i !== -1) {
        Vue.set(state.shippingOfflineLocations, i, n);
        if (state.shippingOfflineLocation.id === n.id) state.shippingOfflineLocation = n;
      }
    },
    remove(state, id) {
      const i = _.findIndex(state.shippingOfflineLocations, { id });
      Vue.delete(state.shippingOfflineLocations, i);
    },
    setShippingOfflineLocationForm(state, shippingOfflineLocationForm) {
      state.shippingOfflineLocationForm = shippingOfflineLocationForm;
    },
    toggleShippingOfflineLocationForm(state, operation) {
      if (operation === 'create') state.shippingOfflineLocation = {};
      state.operation = operation;
      state.shippingOfflineLocationForm = !state.shippingOfflineLocationForm;
    },
    setPending(state, pending) {
      state.pending = pending;
    },
    clearState(state) {
      state.shippingOfflineLocations = [];
      state.shippingOfflineLocation = {};
      state.shippingOfflineLocationForm = false;
      state.pending = false;
    }
  },
  actions: {
    async fetchShippingOfflineLocations({ state, commit }) {
      try {
        state.pending = true;
        const res = await axios.get('/shipping-offline-locations');
        if (res && res.data) {
          commit('setShippingOfflineLocations', res.data.shippingOfflineLocations);
        }
      } finally {
        state.pending = false;
      }
    },
    async createShippingOfflineLocation({ state, commit }, sl) {
      try {
        state.pending = true;
        const res = await axios.post(`/shipping-offline-locations`, sl);
        if (res && res.data) {
          commit('append', res.data.shippingOfflineLocation);
          commit('setShippingOfflineLocation', res.data.shippingOfflineLocation);
        }
      } finally {
        state.pending = false;
      }
    },
    async updateShippingOfflineLocation({ commit }, sl) {
      sl.id = parseInt(sl.id);
      delete sl.user;
      const res = await axios.patch(`/shipping-offline-locations/${sl.id}`, sl);
      if (res && res.data) commit('replace', { o: sl, n: res.data.shippingOfflineLocation });
    },
    async deleteShippingOfflineLocation({ commit }, { id }) {
      const res = await axios.delete(`/shipping-offline-locations/${id}`);
      if (res && res.data) commit('remove', id);
    },
    async assignLoadOfflineShippingLocation(_, { spRunNum, offlineLocationName }) {
      await axios.post(`/shippings/${spRunNum}/assign-offline-location/${offlineLocationName}`);
    }
  }
};
